'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;
var hasRenderedMap = false;

function init() {
    if (!hasRenderedMap) {
        setTimeout(function () {
            !hasRenderedMap && initMap();
        }, 1250);
    }
}

function initMap() {
    if (typeof window.google === 'undefined') {
        return;
    }

    var mapElements = document.querySelector('.js-map');
    if (!mapElements) {
        return;
    }

    var _mapElements$dataset = mapElements.dataset,
        lat = _mapElements$dataset.lat,
        lng = _mapElements$dataset.lng,
        title = _mapElements$dataset.title;
    var _window$google$maps = window.google.maps,
        Map = _window$google$maps.Map,
        Marker = _window$google$maps.Marker;

    var latLng = { lat: +lat || 51.274514, lng: +lng || -1.1032106 };
    var markerTitle = title || 'Vivid Homes';
    var customIcon = {
        path: 'M3.1 28.49l15.26 22.87L33.6 28.49C41.72 16.3 33 0 18.36 0S-5.01 16.31 3.1 28.49z',
        anchor: new window.google.maps.Point(18.4, 51),
        fillColor: '#fc4c02',
        fillOpacity: 1,
        scale: 1,
        strokeOpacity: 0
    };

    var map = new Map(mapElements, {
        zoom: 15,
        center: latLng,
        scrollwheel: false,
        gestureHandling: 'cooperative'
    });

    new Marker({
        position: latLng,
        map: map,
        title: markerTitle,
        icon: customIcon
    });

    hasRenderedMap = true;
}
window.initMap = initMap;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/map.js
// module id = ./resources/assets/js/src/ui/map.js
// module chunks = 0